import { createBrowserRouter } from "react-router";
import { Navigate } from "react-router";

import AdminLogin from "../Pages/AdminLogin";

import AdminIndex from "./../Pages/AdminIndex"
import Homepage from "../Pages/Homepage";

import Rechnungen from "./../Pages/Rechnungen"
import GutscheineGeschenke from "../Pages/Gutscheine_Geschenke";
import Statistiken from "../Pages/Statistiken";
import Einstellungen from "../Pages/Einstellungen";
import CalendarReserviton from "../Pages/Calendar_Reserviton ";
import ResetPassword from "../Pages/Forget_Password";
import Error from "../Pages/error";
import Success from "../Pages/Success";

import {ExtraobjetRoutes} from "./Extra_Object_Routes"
import { ReservationsRoutes} from "./Reservations_Routes";
import { PackagesRoutes } from "./Packages_Routes";
import { AdminUserRoutes } from "./Admin_User_Routes";
import { UsersRoutes } from "./Users_Routes";

const role=localStorage.getItem("role")
export const router = createBrowserRouter([
  {
    path: "/AdminLogin",
    element: <AdminLogin/>
  },
  {
    path: "/ResetPassword/:token",
    element: <ResetPassword/> 
  },
  {
    path: "/Error",
    element: <Error/> 
  },
  {
    path: "/Success",
    element: <Success/> 
  },
  {
    path: '/',
    element: <AdminIndex />,
    errorElement: <Error />,
    children: [
      {
        index: true,
        element: <Homepage/>
      },
      ...ReservationsRoutes,
      ...AdminUserRoutes,
      ... PackagesRoutes ,
      ... UsersRoutes,
      ...ExtraobjetRoutes ,
      {
        path: "Gutscheine&Geschenke",
        element: <GutscheineGeschenke/>
      },
      {
        path: "Statistiken",
        element: role != 'manager' ? <Navigate to="/" replace /> : <Statistiken/>
      },
      {
        path: "Einstellungen",
        element: <Einstellungen/>
      },
      {
        path: "Rechnungen",
        element: <Rechnungen/>
        
      },
      {
        path: "calendar",
        element: <CalendarReserviton/> 
      },
    ]
  },
  {
    path: "*",
    element: <Navigate to="/" replace />
  }
]);